/*  ==========================================================================
    CONTENTCLUSTER ARTICLE
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';
import * as utils from '../../utilities/utils';

/*
 * MODULE
 */

export function initCcArticle($element) {

    // magnific popup
    utils.mfp.initSingleImage($element);

}


// WEBPACK FOOTER //
// ./source/js/modules/lib/cc-article.js